import React from 'react'
import Text from './Text'

type TeamMemberCardProps = {
  member: { name: string; image?: string }
}

function TeamMemberCard({ member }: TeamMemberCardProps) {
  const { name, image } = member
  return (
    <figure className="m-0">
      <div className="w-full overflow-hidden bg-lightGray">
        <img src={image} alt="" className="w-full object-cover object-top aspect-[16/11]" />
      </div>
      <Text text={name} className="mt-3 font-[400]" size="xlarge" />
    </figure>
  )
}

export default TeamMemberCard
